module.exports = __webpack_public_path__ + "static/media/edu.8b183313.svg";